// extracted by mini-css-extract-plugin
export default {"form":"r9YvYkMa","mobile":"mobile","row":"QFQBgbmF","field":"w2lXqQll","phoneConfirm":"kBcNApd6","footer":"fsQmdMUs"};